/**
 * Attempt fall-back to direct link to youtube video.
 */
export const getYouTubeIDFromViewLink = link =>
	link && link.indexOf('https://www.youtube.com/watch?v=') === 0
		? link.split('https://www.youtube.com/watch?v=')[1]
		: link;

/**
 * First prefer the official link sharing format. i.e. https://youtu.be/{id}
 */
export const getYouTubeID = link =>
	link && link.indexOf('https://youtu.be/') === 0
		? link.split('https://youtu.be/')[1]
		: getYouTubeIDFromViewLink(link);



// WEBPACK FOOTER //
// ./src/profile/youtube.js